import { useEffect, useState } from 'react'
import { API_URL } from '../lib/config'

const CONSENT_KEY = 'fyr_ref_consent'
const REF_KEY = 'fyr_ref_pending'

export default function ReferralConsentBanner() {
  const [refCode, setRefCode] = useState<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref')
    if (ref) {
      sessionStorage.setItem(REF_KEY, ref)
      params.delete('ref')
      const clean = window.location.pathname + (params.toString() ? `?${params}` : '')
      window.history.replaceState({}, '', clean)
    }

    const pending = ref || sessionStorage.getItem(REF_KEY)
    if (pending && !localStorage.getItem(CONSENT_KEY)) {
      setRefCode(pending)
    }
  }, [])

  if (!refCode) return null

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined')
    sessionStorage.removeItem(REF_KEY)
    setRefCode(null)
  }

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    sessionStorage.removeItem(REF_KEY)
    const returnUrl = window.location.origin + window.location.pathname
    window.location.href = `${API_URL}/r/consent-accept?code=${encodeURIComponent(refCode!)}&return_url=${encodeURIComponent(returnUrl)}`
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] bg-neutral-900 text-white px-4 py-4 sm:py-3 flex flex-col sm:flex-row items-center justify-between gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.2)]">
      <p className="text-sm text-neutral-200 text-center sm:text-left">
        Wir möchten ein Cookie setzen, um Ihre Empfehlung korrekt zuzuordnen. Mehr dazu in unserer{' '}
        <a href="/datenschutz" className="underline hover:text-white">Datenschutzerklärung</a>.
      </p>
      <div className="flex gap-2 shrink-0">
        <button
          type="button"
          onClick={decline}
          className="px-4 py-2 text-sm font-medium rounded-lg border border-neutral-600 text-neutral-200 hover:bg-neutral-800 transition-colors"
        >
          Ablehnen
        </button>
        <button
          type="button"
          onClick={accept}
          className="px-4 py-2 text-sm font-semibold rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
        >
          Akzeptieren
        </button>
      </div>
    </div>
  )
}
